import {STORAGE_KEY, LOCALE_LIST} from "./constants";

export const getNavigatorLang = () => {
  let lang = localStorage.getItem(STORAGE_KEY.LANG);
  document.documentElement.lang = lang;
  if (lang && LOCALE_LIST.includes(lang)) return lang;

  let str;
  if (navigator.languages && navigator.languages.length) {
    str = navigator.languages[0];
  } else {
    str = navigator.userLanguage || navigator.language || navigator.browserLanguage || "en";
  }
  lang = str.replace(/-[A-Z]*/, "");
  if (!LOCALE_LIST.includes(lang)) lang = "en";
  localStorage.setItem(STORAGE_KEY.LANG, lang);
  return lang;
};
